/*
 * Browser shim for `class-validator`.
 *
 * WEB imports api/src DTOs for their shapes and values. Those DTOs are decorated with
 * class-validator (@IsString, @IsUUID, @IsPhoneNumber, ...), which drags class-validator plus
 * its `validator` dependency and — via @IsPhoneNumber — `libphonenumber-js` (~58 KB total) into
 * the browser bundle, even though WEB never runs validation.
 *
 * This stub:
 *   - turns every decorator (@IsX / PascalCase) into a no-op, so DTO/entity classes still define
 *     and construct normally;
 *   - keeps the handful of lowercase *runtime helper functions* the codebase actually calls
 *     working with real implementations (isArray/isBoolean are used in WEB; isString/isUUID/
 *     isObject/isEmail/validate appear in api utils that WEB can reach);
 *   - resolves validate()/validateSync() to "no errors" (these never run in the browser).
 */

function noop() {}

// Decorator factory / internal helper (registerDecorator, buildMessage, ...): no-op.
function stub() {
	return noop;
}

// Real implementations for the lowercase validator functions that may execute in the browser.
var real = {
	isDefined: function (v) {
		return v !== null && v !== undefined;
	},
	isArray: Array.isArray,
	isBoolean: function (v) {
		return typeof v === 'boolean' || v instanceof Boolean;
	},
	isString: function (v) {
		return typeof v === 'string' || v instanceof String;
	},
	isNumber: function (v) {
		return typeof v === 'number' && Number.isFinite(v);
	},
	isInt: function (v) {
		return typeof v === 'number' && Number.isInteger(v);
	},
	isObject: function (v) {
		return v !== null && (typeof v === 'object' || typeof v === 'function');
	},
	isEmpty: function (v) {
		return v === '' || v === null || v === undefined;
	},
	isNotEmpty: function (v) {
		return !(v === '' || v === null || v === undefined);
	},
	isDate: function (v) {
		return v instanceof Date && !isNaN(v.getTime());
	},
	isUUID: function (v) {
		return (
			typeof v === 'string' &&
			/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(v)
		);
	},
	isEmail: function (v) {
		return typeof v === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
	},
	// Validation entry points are server-only; treat everything as valid in the browser.
	validate: function () {
		return Promise.resolve([]);
	},
	validateSync: function () {
		return [];
	},
	validateOrReject: function () {
		return Promise.resolve();
	}
};

const handler = {
	get: function (target, prop) {
		if (prop === '__esModule') return true;
		if (prop === 'default') return proxy;
		if (typeof prop === 'symbol') return undefined;
		if (Object.prototype.hasOwnProperty.call(real, prop)) return real[prop];
		return stub;
	}
};

const proxy = new Proxy(function () {}, handler);

module.exports = proxy;
